import type { PostHogBootstrapData } from '../getPostHogBootstrapData';

import { posthog } from './posthog';

export { trackIdentityLink } from './identity-link';

export function initAnalyticsServices(postHogBootstrapData: PostHogBootstrapData | null) {
  try {
    posthog.init(postHogBootstrapData);
  } catch (error) {
    console.error('Failed to initialize posthog client', { error });
  }
}

export { posthog };
